<template>
  <div class="session-dlg">
    <div class="dialog-content">
      <p>
        {{ message }}
        <bouncing-spinner class="spinner"></bouncing-spinner>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  methods: {},
  props: {
    message: {
        default: 'Uw sessie is verlopen, log opnieuw in om verder te gaan.'
      }
  },
  created() {
    setTimeout(() => {
      this.$emit('close')
    }, 3000)
  }
}
</script>

<style lang="scss" scoped>
.session-dlg {
  text-align: center;
}

.spinner {
  margin-top: 18px;
}
</style>
